export default "__VITE_ASSET__DZcOmiyh__"